import { render, staticRenderFns } from "./CoBrandedBanner.vue?vue&type=template&id=260d5ecc&scoped=true"
import script from "./CoBrandedBanner.vue?vue&type=script&lang=js"
export * from "./CoBrandedBanner.vue?vue&type=script&lang=js"
import style0 from "./CoBrandedBanner.vue?vue&type=style&index=0&id=260d5ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260d5ecc",
  null
  
)

export default component.exports